'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _createNumberMask = require('text-mask-addons/dist/createNumberMask');

var _createNumberMask2 = _interopRequireDefault(_createNumberMask);

var _PixelsInput = require('./PixelsInput.scss');

var _PixelsInput2 = _interopRequireDefault(_PixelsInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PixelsInput = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PixelsInput, _Component);

  function PixelsInput(props) {
    (0, _classCallCheck3.default)(this, PixelsInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PixelsInput.__proto__ || (0, _getPrototypeOf2.default)(PixelsInput)).call(this, props));

    _this.pipe = function (conformedValue) {
      if (conformedValue.indexOf('px') >= 0) return conformedValue;
      return conformedValue + 'px';
    };

    _this._onChange = function (event) {
      var onChange = _this.props.onChange;

      if (onChange) onChange(event);
    };

    _this._onIncrement = function (increment, event) {
      // TODO:Refactor? Neater way?
      var value = _this.props.value;

      var input = _this.input && _this.input.input;
      var inputElement = input && input.inputElement;

      if (inputElement) {
        inputElement.value = Number(value.replace(/\D/g, '')) + increment + 'px';
        input.onChange((0, _create2.default)(event, { target: { value: inputElement } }));
      }
    };

    _this.input = null;
    return _this;
  }

  (0, _createClass3.default)(PixelsInput, [{
    key: '_renderControls',
    value: function _renderControls() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: _PixelsInput2.default.controls },
        _react2.default.createElement(
          'button',
          { className: _PixelsInput2.default.controlsItem, onClick: function onClick(e) {
              return _this2._onIncrement(1, e);
            } },
          '+'
        ),
        _react2.default.createElement(
          'button',
          { className: _PixelsInput2.default.controlsItem, onClick: function onClick(e) {
              return _this2._onIncrement(-1, e);
            } },
          '-'
        )
      );
    }
  }, {
    key: '_renderInput',
    value: function _renderInput(props) {
      var _this3 = this;

      return _react2.default.createElement(_components.EnterpriseInput, (0, _extends3.default)({
        pipe: this.pipe,
        mask: this.mask
      }, props, {
        onChange: this._onChange,
        ref: function ref(component) {
          _this3.input = component;
        }
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          controls = _props.controls,
          props = (0, _objectWithoutProperties3.default)(_props, ['controls']);


      if (!controls) return this._renderInput(props);

      return _react2.default.createElement(
        'div',
        { className: _PixelsInput2.default.wrapper },
        this._renderInput(props),
        this._renderControls(props)
      );
    }
  }, {
    key: 'mask',
    get: function get() {
      return (0, _createNumberMask2.default)({
        prefix: '',
        suffix: 'px',
        includeThousandsSeparator: false
      });
    }
  }]);
  return PixelsInput;
}(_react.Component), _class.propTypes = {
  value: _react.PropTypes.any,
  controls: _react.PropTypes.bool,
  onChange: _react.PropTypes.func
}, _class.defaultProps = {
  controls: false,
  onChange: function onChange() {}
}, _temp);
exports.default = PixelsInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PixelsInput/PixelsInput.jsx
// module id = 1577
// module chunks = 0